import 'devextreme/dist/css/dx.light.css';
import React  from "react";
import "./footer.css";

function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <div className="footer-container">
        <p>
          Copyright © 2011-{currentYear} Ithena.
          <br />
          All trademarks or registered trademarks are property of their
          respective owners.
          <br />
          <a
            href="http://eula.ithena.io/"
            target="_blank"
            rel="noopener noreferrer"
            className="link-style"
          >
            Terms
          </a>
          •
          <a
            href="http://privacy.ithena.io/"
            target="_blank"
            rel="noopener noreferrer"
            className="link-style"
          >
            Privacy
          </a>
        </p>
    </div>
  );
}

export default Footer;
